import React, { PropTypes } from 'react';
import partial from 'lodash/partial';
import ConfirmationDialog from 'common/components/modal/confirmation_dialog';

const DeleteModal = ({ entry, user, deleteEntry, toggle }) => {
  if (!entry) {
    return null;
  }

  const action = entry.author === user.id? 'withdraw' : 'eliminate';

  return (
    <ConfirmationDialog
      dialogHeader={`${action} Entry`}
      dialogTitle={`Are you sure you want to ${action} this entry?`}
      dialogMessage={`You can add it back to the project later.`}
      dialogVisible={true}
      primaryActionText={`Yes, ${action}`}
      toggleDialog={toggle}
      submitAction={partial(deleteEntry, entry)}
    />
  );
}

DeleteModal.propTypes = {
  entry: PropTypes.object,
  user: PropTypes.object.isRequired,
  deleteEntry: PropTypes.func.isRequired,
  toggle: PropTypes.func.isRequired
};

export default DeleteModal;



// WEBPACK FOOTER //
// ./entries/components/delete_modal.jsx